/**
 * ตารางในเนื้อหาบทความ
 *
 * แหล่งเดียวของหน้าตาตาราง ใช้ร่วมกันระหว่างหน้าแก้ไขกับหน้าบล็อกจริง
 * ด้วยเหตุผลเดียวกับรูป (ดู figure.ts) — ถ้าแยกกันเขียน สิ่งที่ผู้เขียนจัดไว้จะไม่ตรงกับที่ผู้อ่านเห็น
 */
/** กล่องครอบตารางฝั่ง server — ฝั่งหน้าแก้ไข TipTap สร้าง .tableWrapper ให้เอง */
export const TABLE_WRAPPER_CLASS = 'ba-table';
/** ความกว้างขั้นต่ำของคอลัมน์ ถ้าแคบกว่านี้ข้อความไทยจะตัดคำจนอ่านไม่ออก */
export const TABLE_MIN_COL_WIDTH = 64;
/**
 * @param scope   selector ของกล่องเนื้อหา เช่น '.tiptap' หรือ '.prose'
 * @param tokens  สีที่แต่ละฝั่งใช้ (admin กับบล็อกใช้ชื่อตัวแปรคนละชุด)
 * @param editing ใส่กฎเฉพาะหน้าแก้ไข (เซลล์ที่เลือก, ที่จับปรับความกว้าง)
 *                หน้าบล็อกไม่ต้องใช้ และ CSS ของบล็อกถูก inline ทุกหน้า จึงไม่ควรพ่วงของไม่จำเป็น
 */
export function tableCss(scope, tokens, editing = false) {
    const s = scope;
    const base = `
/* กล่องครอบ: ตารางกว้างกว่าคอลัมน์เนื้อหาได้ ให้เลื่อนในกล่องตัวเอง ไม่ดันทั้งหน้าให้เลื่อนตาม */
${s} .${TABLE_WRAPPER_CLASS},${s} .tableWrapper{overflow-x:auto;margin:1.7em 0;max-width:100%}
${s} table{border-collapse:collapse;table-layout:fixed;width:100%;margin:0;
  font-size:.9375rem;line-height:1.65}
${s} th,${s} td{border:1px solid ${tokens.line};padding:8px 12px;text-align:left;
  vertical-align:top;box-sizing:border-box;min-width:${TABLE_MIN_COL_WIDTH}px;position:relative}
${s} th{background:${tokens.head};font-weight:650}
/* ย่อหน้าในเซลล์ไม่ต้องมีระยะห่างบน-ล่าง ไม่งั้นเซลล์จะสูงเกินจำเป็น */
${s} th>*:first-child,${s} td>*:first-child{margin-top:0}
${s} th>*:last-child,${s} td>*:last-child{margin-bottom:0}`;
    if (!editing)
        return base;
    return `${base}
/* ---- เฉพาะหน้าแก้ไข ---- */
${s} table{overflow:hidden}
${s} .selectedCell::after{content:"";position:absolute;inset:0;pointer-events:none;
  background:color-mix(in srgb,${tokens.accent ?? tokens.line} 18%,transparent)}
${s} .column-resize-handle{position:absolute;right:-2px;top:0;bottom:0;width:4px;z-index:5;
  background:${tokens.accent ?? tokens.line};pointer-events:none}
${s} .tableWrapper.resize-cursor,${s} .tableWrapper.resize-cursor *{cursor:col-resize}`;
}
/* ------------------------------------------------------------------ *
 * การจัดแนวตั้งในเซลล์
 * ------------------------------------------------------------------ */
export const CELL_VERTICAL_ALIGNS = ['top', 'middle', 'bottom'];
/** ค่าเริ่มต้นคือชิดบน ตรงกับ vertical-align ที่ tableCss ตั้งไว้ */
export function cellVerticalAlign(v) {
    return typeof v === 'string' && CELL_VERTICAL_ALIGNS.includes(v)
        ? v
        : 'top';
}
/* ------------------------------------------------------------------ *
 * การจัดข้อความในแนวนอน
 * ------------------------------------------------------------------ */
export const TEXT_ALIGNS = ['left', 'center', 'right', 'justify'];
export function isTextAlign(v) {
    return typeof v === 'string' && TEXT_ALIGNS.includes(v);
}
//# sourceMappingURL=table.js.map